const cache = require('memory-cache');

export default class Memory {

    setItem(key, value, ttl) {
        return cache.put(key, value, ttl);
    }

    getItem(key) {
        return cache.get(key);
    }

} 